<template>
  <v-navigation-drawer
    v-model="drawer"
    @input="onClose"
    right
    app
    temporary
    width="600"
    class="pa-4"
  >
    <p class="title" @click="close()">
      {{ id ? "Alteração" : "Cadastro" }} de peça
      <v-btn icon class="float-right">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </p>
    <v-divider class="mb-4"></v-divider>

    <FormularioGerenciarPeca
      ref="formularioGerenciarPeca"
      @salvar="this.salvar"
      :id="id"
    />
  </v-navigation-drawer>
</template>

<script>
import  { api } from "../../../../api";
import FormularioGerenciarPeca from "../forms/FormularioGerenciarPeca.vue";

export default {
  name: "IziManNavigationDrawerGerenciarPeca",
  components: { FormularioGerenciarPeca },
  data() {
    return {
      id: null,
      drawer: false,
    };
  },
  methods: {
    show(id = null) {
      this.id = id;
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },

    onClose(event) {
      !event && this.$refs.formularioGerenciarPeca.$refs.form.reset();
    },
    async salvar(body) {
      try {
        const response = !this.id
          ? await api.post("/item", body)
          : await api.put(`/item/${this.id}`, body);
        if (response.data) {
          this.$root.GlobalMessage.success("Operação realizada com sucesso!");
          this.$refs.formularioGerenciarPeca.$refs.form.reset();
          this.$emit("salvo", response.data);
          this.close();
        } else this.$root.GlobalMessage.error("Erro ao cadastrar Peça!");
      } catch (err) {
        this.$root.GlobalMessage.error(
          "Erro ao realizar requisição, entre em contato com o administrador!"
        );
      }
    },
  },
};
</script>
